import { Directive, inject, effect, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserStore } from 'app/core/services/user.store';
import { NavigationService } from '../../navigation/navigation.service';

@Directive({
  selector: '[hideForPublicPage]',
  standalone: true,
})
export class HideForPublicPageDirective {
  isHidden = true;

  navigationService = inject(NavigationService);

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    effect(() => {
      if (this.navigationService.currentPageIsPublic()) {
        this.updateView();
      } else {
        this.updateView();
      }
    });
  }

  private updateView() {
    if (this.showElement() && this.isHidden) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isHidden = false;
    } else if (!this.showElement()) {
      this.isHidden = true;
      this.viewContainer.clear();
    }
  }

  private showElement() {
    return !this.navigationService.currentPageIsPublic();
  }
}
